export default {
  data () {
    return {
      screenSizeIsSmall: false
    }
  },
  methods: {
    onResize () {
      this.checkScreenSize()
    },
    checkScreenSize () {
      this.screenSizeIsSmall = window.innerWidth < 700
    }
  }
}
